// Svelte-free by design, so a `node:test` file can exercise it.

/**
 * Quale avviso mostrare sopra lo scadenzario.
 *
 * `totalsPartial` quando il server si è fermato al limite di sicurezza: i totali
 * sono parziali — possono risultare più alti o più bassi di quelli veri, per
 * esempio se manca una nota di credito — e va detto prima di qualunque cifra.
 * `listCut` quando si è fermato soltanto l'elenco: i totali restano completi.
 * Null quando la risposta copre tutto.
 *
 * @param {{truncated?: boolean, totalsTruncated?: boolean}|null|undefined} data
 * @returns {'totalsPartial'|'listCut'|null}
 */
export function scadenzeNotice(data) {
  if (data?.totalsTruncated === true) return 'totalsPartial';
  if (data?.truncated === true) return 'listCut';
  return null;
}
